
import React, { useState, useEffect, useContext } from 'react'
import Axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import FixtureStatistics from './FixtureTemplates/FixtureStatistics';
import FixtureTabs from './FixtureTemplates/FixtureTabs';
import FixtureEvents from './FixtureTemplates/FixtureEvents';
import FixtureLineups from './FixtureTemplates/FixtureLineups';
import FixtureMain from './FixtureTemplates/FixtureMain';
import Loader from '../../../Loader/Loader';
import FixtureEventTable from './FixtureTemplates/FixtureEventsTable';
import { getSingleFixture } from '../../../../api/api_football';
import LeagueStandings from '../League/LeagueStandings';

function SingleFixture() {
    const { id } = useParams();


    const [fixture, setFixture] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [activeItem, setActiveItem] = useState("1")
    const [requestCount, setRequestCount] = useState(0)
    const [requestInterval, setRequestInterval] = useState(60000)

    // Refresh score every 30 seconds for live fixture
    useEffect(() => {
        console.log(fixture, "FIXTURE")
        if (fixture && fixture.elapsed && fixture.elapsed > 0 && fixture.elapsed <= 90 && fixture.statusShort !== "FT" && fixture.statusShort !== "PST" && fixture.statusShort !== "HT") {
            const interval = setInterval(() => {
                setRequestCount(requestCount => requestCount + 1)
            }, requestInterval);

            return () => clearInterval(interval);
        }


    }, [fixture]);

    useEffect(() => {

        console.log(requestCount, "requestcount")

        async function fetchSingleFixture() {
            if (requestCount <= 1) {
                window.scrollTo(0, 0)
            }

            setIsLoading(true)
            try {
                const data = await getSingleFixture(id)
                setFixture(data)
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)
        }
        fetchSingleFixture()

    }, [id, requestCount])

    function formatDateShort(dateFixture) {

        let date = new Date(dateFixture);
        let month = date.getMonth() + 1
        const dateFormatted = `${date.getDate()}/${month} kl ${date.getHours()}:${date.getMinutes()}0`

        return dateFormatted
    }

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    if (isLoading && requestCount <= 0) return <div className="my-4"><Loader /></div>

    return (
        <div className="">
            <div className="container pt-1 pb-3">

                {fixture && (
                    <React.Fragment>
                        <FixtureMain fixture={fixture} formatDateShort={formatDateShort} />

                        <FixtureTabs toggle={toggle} activeItem={activeItem} />

                        {isLoading && <div className="my-4"><Loader /></div>}

                        {activeItem === "1" &&

                            <FixtureLineups fixture={fixture} />
                        }

                        {activeItem === "2" &&
                            <>
                                {fixture.statistics ?
                                    <FixtureStatistics fixture={fixture} />
                                    : "Not stats"}
                            </>
                        }

                        {activeItem === "3" &&
                            <div className="mb-3">
                                {fixture.events ? fixture.events.map((event, index) => {
                                    return (
                                        <FixtureEvents key={index} event={event} />
                                    )
                                }) : "No events yet"}

                                {fixture.events && <FixtureEventTable events={fixture.events} />}
                            </div>
                        }
                        {activeItem === "4" && <LeagueStandings season={2019} id={fixture.league_id} />}
                    </React.Fragment>
                )}

            </div>
        </div>
    )

}
export default SingleFixture
